import BaseService from './base.service';

class ProductsModulesService extends BaseService {
  get basePath() {
    return 'product/modules';
  }
}

export default new ProductsModulesService();
